/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setQBProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import Question from 'material/embeds/content/shared/question/question';



/* ========== ~~~~~~~~~~ EMBED : QUESTION : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    contentTitle: embedsState.embedManagementState.contentStatus.contents[contentId]['questionBased']['title'],
    isValid: embedsState.embedManagementState.contentStatus.contents[contentId]['questionBased']['isTitleValid']
});


const mapDispatchToProps = dispatch => ({
    setQBProperty: (contentId, property, value) => dispatch(setQBProperty(contentId, property, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Question);
